"use client"

import AssetComboIcon from "../DefuseSDK/components/Asset/AssetComboIcon"

const rwaTokens = [
  {
    symbol: "AAPL",
    icon: "/static/icons/market/aapl.svg",
    amount: 28,
    price: 313.52,
  },
  {
    symbol: "SPY",
    icon: "/static/icons/market/sp500.svg",
    amount: 9,
    price: 773.26,
  },
  {
    symbol: "AMZN",
    icon: "/static/icons/market/amzn.svg",
    amount: 15,
    price: 274.48,
  },
  {
    symbol: "GLD",
    icon: "/static/icons/market/gold.svg",
    amount: 9,
    price: 403.12,
  },
] as const

function formatted(value: number, digits: number) {
  return value.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })
}

const RwaIllustration = () => {
  return (
    <div className="w-full max-w-[min(85vw,26rem)] space-y-1 rounded-2xl border border-white/5 bg-gray-900 p-1">
      {rwaTokens.map((token) => (
        <div
          key={token.symbol}
          className="flex items-center gap-3 rounded-xl border border-white/5 bg-gray-850 p-5"
        >
          <AssetComboIcon icon={token.icon} sizeClassName="size-12" />
          <div className="flex flex-col">
            <div className="font-semibold text-base/5 text-white tracking-tighter">
              {formatted(token.amount, 0)} {token.symbol}
            </div>
            <div className="font-medium text-gray-400 text-sm/5 tracking-tighter">
              ${formatted(token.amount * token.price, 2)}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default RwaIllustration
